export default __webpack_public_path__ + "static/media/avatar_3.62c53150.svg";